// @ts-nocheck
import request from '../utils/request';
export function loadClinics(expand = false, filters) {
    const params = new URLSearchParams();
    if (expand)
        params.append('expand', 'true');
    if (filters?.search?.trim())
        params.append('search', filters.search.trim());
    if (filters?.approval_status)
        params.append('approval_status', filters.approval_status);
    if (filters?.is_active !== undefined)
        params.append('is_active', String(filters.is_active));
    if (filters?.sales_rep)
        params.append('sales_rep', filters.sales_rep);
    const query = params.toString();
    const url = query ? `/api/v1/clinics/?${query}` : '/api/v1/clinics/';
    return request().get(url).send();
}
export function getCorporateGroups() {
    return request(false) // Don't force login for this endpoint since it's AllowAny
        .get(`/api/v1/corporate-groups/`)
        .send();
}
export function updateClinic(clinicId, data) {
    return request().patch(`/api/v1/clinics/${clinicId}/?expand=true`).send(data);
}
export function createClinic(data) {
    return request().post('/api/v1/clinics/?expand=true').send(data);
}
export function searchPaymentCustomers(filters) {
    const params = new URLSearchParams();
    if (filters?.search?.trim()) {
        params.append('search', filters.search.trim());
    }
    const query = params.toString();
    const url = query
        ? `/api/v1/admin/payment-customers/?${query}`
        : '/api/v1/admin/payment-customers/';
    return request().get(url).send();
}
export function getClinic(clinicId) {
    return request()
        .get(`/api/v1/clinics/${clinicId}/?expand=true`)
        .send();
}
export async function getClinicOrderStats(clinicId) {
    const response = await request()
        .get(`/api/v1/clinics/${clinicId}/order-stats/`)
        .send();
    return response.body;
}
// export function loadClinicDetails(clinicId:string):SuperAgentRequest {
//     return request()
//         .get(`/api/v1/clinics/${clinicId}`)
//         .send();
// }
//
// export function loadClinicUsers():SuperAgentRequest {
//     return request()
//         .get("/api/v1/clinic-users/")
//         .send();
// }
